let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gc3a2")).then(() => parcelRequire('af3P6'));